import { render, staticRenderFns } from "./AssetsSummary.vue?vue&type=template&id=83a7226a&scoped=true"
import script from "./AssetsSummary.vue?vue&type=script&lang=js"
export * from "./AssetsSummary.vue?vue&type=script&lang=js"
import style0 from "./AssetsSummary.vue?vue&type=style&index=0&id=83a7226a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83a7226a",
  null
  
)

export default component.exports